import { AudRestrictions } from "./currencyRestrictions/Aud";
import { EurRestrictions } from "./currencyRestrictions/Eur";
import { GbpRestrictions } from "./currencyRestrictions/Gbp";
import { UsdRestrictions } from "./currencyRestrictions/Usd";

const transactionHighLowRestrictions = {
  AUD: AudRestrictions,
  EU: EurRestrictions,
  GBP: GbpRestrictions,
  USD: UsdRestrictions
};

export function getHighLowRestriction(date, currency) {
  const currencyRestrictions = transactionHighLowRestrictions[currency] ?? transactionHighLowRestrictions.AUD;

  const dateKey = toDateKey(date);
  const restriction = currencyRestrictions[dateKey];

  return {
    highLimit: restriction?.high ?? null,
    lowLimit: restriction?.low ?? null
  };
}

function toDateKey(date) {
  const d = new Date(date);

  if (Number.isNaN(d.getTime())) {
    return null;
  }

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function parseCurrency(currency) {
  const parsedCurrency = Object.keys(transactionHighLowRestrictions).includes(currency) ? currency : "AUD";
  return parsedCurrency;
}

export function getCurrencySymbol(currency) {
  const symbol = currency === "AUD" ? "$" : currency === "USD" ? "$" : currency === "EU" ? "€" : currency === "GBP" ? "£" : "$";
  return symbol;
}
